<template>
  <div class="custome-file-upload">
    <div class="file-list" v-if="currentFileList.length">
      <div v-for="(item, index) in currentFileList" :key="index" class="file-list-item">
        <div class="file-item-content">
          <div class="file-item-content-word">
            <i class="el-icon-document doc"></i>
          </div>
        </div>
        <div class="file-item-action-group">
          <span class="file-name">{{ item.sourceFileName || item.fileName }}</span>
          <div class="file-action">
            <el-tooltip effect="dark" content="预览" placement="bottom">
              <i class="el-icon-view file-action-item" @click="previewFile(item)"></i>
            </el-tooltip>
            <el-tooltip effect="dark" content="删除" placement="bottom">
              <i class="el-icon-delete file-action-item" @click="deleteFile(index)"></i>
            </el-tooltip>
          </div>
        </div>
      </div>
    </div>
    <div class="file-upload-bt">
      <div @click="handleUploadFile" class="custome-upload">
        <i class="el-icon-plus custome-upload-icon"></i>
      </div>
    </div>
    <input type="file" ref="fileUploaderInput" @change="fileUpload" hidden accept="image/*,application/pdf" />
  </div>
</template>

<script>
import axios from 'axios'
import fileUpload from '@/mixins/fileUpload'
axios.defaults.withCredentials = true

export default {
  props: {
    fileList: {
      type: Array,
      default: () => [],
    },
    fileType: {
      type: Number,
      default: null,
    },
  },
  data() {
    return {
      currentFileList: [],
    }
  },
  mixins: [fileUpload],
  watch: {
    fileList: {
      handler() {
        this.currentFileList = this.fileList
      },
      immediate: true,
      deep: true,
    },
  },

  mounted() {},

  methods: {
    handleUploadFile() {
      this.$refs.fileUploaderInput.click()
    },

    async fileUpload(e) {
      try {
        if (e.target && e.target.files && e.target.files[0]) {
          const file = e.target.files[0]
          const { name, type, fileId, uploadUrl } = await this.fileChange(file)

          this.currentFileList.push({
            fileName: name,
            fileUrl: uploadUrl,
            fileType: this.fileType,
            fileId,
          })
          this.$emit('getNewFileList', this.currentFileList, this.fileType)
          this.$parent.$emit('el.form.blur')
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.$refs.fileUploaderInput.value = null
      }
    },
    async getfileEditInfo(fileId) {
      const viewFailCode = 412030005
      try {
        const res = await this.$Http.api('', '', {
          url: `webserver/v1/docedit/${fileId}/getOperateUrl`,
          method: 'GET',
          params: {},
          body: {
            // flowTemplateId: flowStartId,
            operateType: 'view',
          },
        })

        const info = res.data
        window.open(info.downloadUrl)
      } catch (err) {
        if (err.code === viewFailCode) {
          await this.getfileReview(fileId)
          throw new Error(err.message)
        }
        this.$message.error(err.message)
        throw new Error(err.message)
      }
    },
    getfileReview(fileId) {
      this.$Http
        .api('', '', {
          url: `webserver/v1/files/${fileId}`,
          method: 'GET',
          params: {},
          body: {
            accountId: 'sys_accountId',
          },
        })
        .then(res => {
          if (res.data && res.data.downloadUrl) {
            window.open(res.data.downloadUrl)
          }
        })
    },
    previewFile(file) {
      this.getfileEditInfo(file.fileId)
    },
    deleteFile(index) {
      this.currentFileList.splice(index, 1)
      this.$emit('getNewFileList', this.currentFileList, this.fileType)
      this.$parent.$emit('el.form.blur')
    },
  },
}
</script>
<style lang="less" scoped>
.custome-file-upload {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  .file-upload-bt {
    margin-top: 10px;
  }
  .file-list {
    display: flex;
  }
  .file-list-item {
    width: 100px;
    border: 1px solid #ddd;
    margin-right: 10px;
  }
  .doc {
    font-size: 36px;
  }
  .file-item-content {
    height: 100px;
    text-align: center;
    border-bottom: 1px solid #ddd;
    background-color: #eee;
    img {
      width: 100%;
    }
  }
  .file-name {
    font-size: 12px;
    text-overflow: ellipsis;
    display: block;
    word-break: keep-all;
    white-space: nowrap;
    overflow: hidden;
    line-height: 16px;
  }
  .file-action {
    display: flex;
    justify-content: flex-end;
  }
  .file-item-action-group {
    padding: 5px 5px 0 5px;
  }
  .file-item-content-word {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .file-action-item {
    display: inline-block;
    width: 18px;
    height: 18px;
    text-align: center;
    line-height: 18px;
  }
}
.custome-upload {
  display: inline-block;
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  .custome-upload-icon {
    font-size: 28px;
    color: #8c939d;
    width: 100px;
    height: 100px;
    line-height: 100px;
    text-align: center;
  }
}
</style>
